import { z } from 'zod'

export const IataSchema = z.enum(['EI', 'BA', 'IB'])

export type Iata = z.infer<typeof IataSchema>

/**
 * ATRP - Avios Travel Rewards Program - Vueling Programme;
 *
 * AERC - Aer Lingus Programme;
 *
 * BAEC - British Airways Executive Club - The loyalty programme for British Airways;
 *
 * IBPL or IB+ - Iberia Plus loyalty programme - The loyalty programme for Iberia;
 *
 * @see https://aviosgroup.atlassian.net/wiki/spaces/ITPT/pages/2172747971/IAGL+Acronyms
 */
export const ProgramIdentifierSchema = z.enum(['BAEC', 'AERC', 'ATRP', 'IBP'])

export type ProgramIdentifier = z.infer<typeof ProgramIdentifierSchema>

export const OpCoClassNameSchema = z.enum(['aer_lingus', 'british_airways', 'iberia'])

export type OpCoClassName = z.infer<typeof OpCoClassNameSchema>

export const OpCoConfigSchema = z.object({
  iataCode: IataSchema,
  key: OpCoClassNameSchema,
  name: z.string(),
})

export type OpCoConfig = z.infer<typeof OpCoConfigSchema>
